// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + ({"214":"polyfills-core-js","748":"polyfills-dom"}[chunkId] || chunkId) + "." + {"214":"f4bdcd91","511":"3faad21b","748":"a1962093","844":"ab201e53"}[chunkId] + ".chunk.js";
};